module.exports = __webpack_public_path__ + "img/p3.914b707a.png";